import axios from 'axios';
import React, { useEffect, useState, memo } from 'react';
import { FaCheckCircle, FaSpinner, FaTimesCircle, FaRedo } from 'react-icons/fa';

const StatusItem = memo(({ method, header, url, whitelistText, loadingText, errorText, successText, onComplete }) => {
	const [serverReached, setServerReached] = useState(null);
	const [loadingServer, setLoadingServer] = useState(true);
	const [retryCount, setRetryCount] = useState(0);

	const checkStatus = async () => {
		setLoadingServer(true);
		try {
			const options = {
				method,
				url,
				headers: header,
				timeout: 10000, // 10 second timeout
			};
			await axios(options);
			setServerReached(true);
		} catch (error) {
			console.error(`Failed to reach ${url}:`, error.message);
			setServerReached(false);
		} finally {
			setLoadingServer(false);
			if (onComplete) onComplete();
		}
	};

	const handleRetry = () => {
		setRetryCount((prev) => prev + 1);
		checkStatus();
	};

	useEffect(() => {
		const timeout = setTimeout(() => {
			checkStatus();
		}, Math.random() * 2000); // Reduced randomness
		return () => clearTimeout(timeout);
	}, [retryCount]);

	const getStatusText = () => {
		if (loadingServer) return loadingText;
		if (serverReached) return successText;
		return retryCount > 0 ? `${errorText} (Attempt ${retryCount + 1})` : errorText;
	};

	const getStatusIcon = () => {
		if (loadingServer) {
			return <FaSpinner className='spinner' style={{ fontSize: 24, color: '#FDDF6D' }} />;
		}
		if (serverReached) {
			return <FaCheckCircle style={{ fontSize: 24, color: '#6FCC87' }} />;
		}
		return <FaTimesCircle style={{ fontSize: 24, color: '#FC4C59' }} />;
	};

	return (
		<div className='status-item'>
			<div className='status-icon'>{getStatusIcon()}</div>
			<div className='status-text'>
				<p className='status-text-value'>{getStatusText()}</p>
				{!loadingServer && serverReached === false && (
					<>
						<p className='whitelist-text'>
							⚠️ Add <b>{whitelistText}</b> to your firewall whitelist
						</p>
						<button
							onClick={handleRetry}
							className='retry-button'
						>
							<FaRedo size={10} /> Retry Connection
						</button>
					</>
				)}
			</div>
		</div>
	);
});

export default StatusItem;
